import Sidebar from './Sidebar';
import Navbar from './Navbar';
import React from 'react';
import './style.css';
import Table from 'react-bootstrap/Table';

import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


const AddProduct = () => {

    let history = useNavigate();

    const [data, setData] = useState({
        productName: "",
        packing: "",
        netWeight: ""
    })

    // start add product id from the database named products
    const [productid, setProductid] = useState("");

    useEffect(() => {
        // Fetch the last productid and increment it
        axios.get("https://react-apis.dotlocalhost.com/getproductid.php")
            .then(response => {
                setProductid(response.data.productid); // Set the incremented productid
            })
            .catch(error => {
                console.error("There was an error fetching the productid!", error);
            });


        // Change background color of the specific sidebar item
        const sidebarItemmatab = document.getElementById("spiceActiveTab");
        if (sidebarItemmatab) {
            sidebarItemmatab.style.backgroundColor = "#C0D4D9"; // Set the color when this component is loaded
            sidebarItemmatab.style.color = "#000000";
        }
        const sidebarItemmain = document.getElementById("othrprdct");
        if (sidebarItemmain) {
            sidebarItemmain.style.backgroundColor = "#C0D4D9"; // Set the color when this component is loaded
            sidebarItemmain.style.color = "#000000";
        }
        const sidebarItem = document.getElementById("adprdct");
        if (sidebarItem) {
            sidebarItem.style.backgroundColor = "#CFE2E7"; // Set the color when this component is loaded
            sidebarItem.style.color = "#000000";
        }        


        // Cleanup function to reset the background color when component unmounts
        return () => {
            if (sidebarItemmatab) {
                sidebarItemmatab.style.backgroundColor = "#F0F0F0"; // Reset to default when component unmounts
                sidebarItemmatab.style.color = "#000000"
            }
            if (sidebarItemmain) {
                sidebarItemmain.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItemmain.style.color = "#000000"
            }
            if (sidebarItem) {
                sidebarItem.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItem.style.color = "#000000";
            }            
        };
    }, []);
    // end add product id from the database named products

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });

        //console.log(data)
    }

    const submitForm = (e) => {
        e.preventDefault();
        const sendData = {
            productName: data.productName,
            packing: data.packing,
            netWeight: data.netWeight,
            productid: productid
        }

        console.log(sendData);

        axios.post('https://react-apis.dotlocalhost.com/products.php', sendData).then((result) => {
            if (result.data.Status == 'Invalid') {
                alert('Invalid User');
            } else {
                history('/viewallproducts');
            }
        })

    }

    return (
        <div class="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />

                <div className='ineerBody'>

                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>Add New Product</h3>
                        </div>
                    </div>

                    <form onSubmit={submitForm}>

                        <input style={{display:'none'}} type="text" id="productid" name='productid' value={productid} />

                        <Table striped bordered hover style={{fontSize: '12px'}}>
                            <thead>
                                <tr style={{textAlign:'center', backgroundColor:'#C0D4D9', color:'#000000'}}>
                                    <th>#</th>
                                    <th><label>Product Name</label></th>
                                    {/* <th>Quantity</th> */}
                                    <th><label>Packing Options</label></th>
                                    <th><label>Net Weight</label></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td><input type="text" name="productName" className='form-control' onChange={handleChange} value={data.productName} autocomplete="off"/></td>
                                    <td>
                                        <select class="form-select" className='form-control' aria-label="Default select example" name="packing" onChange={handleChange} value={data.packing}>
                                            <option selected>Select Packing</option>
                                            <option value="Bags">Bags</option>
                                            <option value="Cartons">Cartons</option>
                                            {/* <option value="3">Three</option> */}
                                        </select>
                                    </td>
                                    <td><input type="text" name="netWeight" className='form-control' onChange={handleChange} value={data.netWeight} autocomplete="off"/></td>
                                </tr>
                            </tbody>
                        </Table>

                        <div className="row">
                            <div className='col-6'>
                                <div className="d-grid gap-3">
                                    <input type="submit" name="submit" value="Add Product" className="btn btn-primary btn-block" />
                                </div>
                            </div>
                        </div>

                    </form>

                </div>

            </div>
        </div>
    )
}

export default AddProduct;